import React from 'react';
import styles from './CopyBtn.module.css';
import { CopySvg } from '../../SVGComponents/SVGComponents';

export default function CopyBtn({ textBtn }) {
  return (
    <button className={styles.btn}>
      <CopySvg />
      {textBtn}
    </button>
  );
}
